import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { DialogData } from 'src/app/entities/dialogData';
import { CheckPayment } from 'src/app/entities/checkPayment';
import { AvisService } from 'src/app/services/avis.service';
import { CategoryService } from 'src/app/services/category.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { DialogCommunicator } from '../dialog-communicator';
import { CompanyDexieService } from 'src/app/services/companyDexie-services/companyDexie.service';
import { TaxNameService } from 'src/app/services/taxName.service';
import { ProcessService } from 'src/app/services/process.service';
import { TranslateService } from "@ngx-translate/core";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'gov-check-payments-dialog',
  templateUrl: './check-payments-dialog.component.html',
  styleUrls: ['./check-payments-dialog.component.css']
})
export class CheckPaymentsDialogComponent extends DialogCommunicator implements OnInit {

  text: string
  emitter: EventEmitter
  fillChequePayment: any
  currentUser: any
  taxNames: any[]
  comp: any;
  isOnline = true;
  selectedAvisList: any[]
  avisTotal: number

  constructor(
    public dialogRef: MatDialogRef<CheckPaymentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public sharedService: SharedService,
    public taxPayerService: TaxPayerService,
    public categoryService: CategoryService,
    public avisService: AvisService,
    public userService: UserService,
    public confirmationDialog: MatDialog, 
    public companyDexieService: CompanyDexieService,
    public taxNameService: TaxNameService,
    public processService: ProcessService,
    public translate: TranslateService
  ) {
    super(dialogRef, sharedService)
    this.setConfirmationDialog(this.confirmationDialog)
  }
  async ngOnInit() {
    this.sharedService.onlineStatus$.subscribe(async status => {
      this.isOnline = status
    })
    this.fillChequePayment = new CheckPayment()
    this.fillChequePayment.date = new Date()
    this.fillChequePayment['class'] = 'CHEQUE-PAYMENT'
    this.setEntity(this.fillChequePayment);
    this.currentUser = await this.getUser()
    this.comp = await this.getcompany()
    this.isOnline ? await this.onlineInit() : await this.offlineInit()
  }

  async getUser() {
    return this.isOnline ? await this.userService.getCurrentUser().toPromise() : await this.companyDexieService.getCurrentUser()
  }

  isAvisPayment(): boolean {
    return this.taxNames && this.taxNames.length > 0 && this.taxNames[0].avis === true;
  }

  async getcompany() {
    return this.isOnline ? await this.taxPayerService.getTaxPayerByNiu("tax-payers", this.data["tin"]).toPromise() :
      await this.companyDexieService.getCompanyByTin(this.data['tin'])
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option === value;
    return false;
  }

  selectChangeTaxNames = (event: any) => {  
    const first = event.data[0];
    const selected = Array.isArray(first) ? first : event.data;
    this.selectedAvisList = selected;
    this.fillChequePayment["taxName"] = selected;
    this.avisTotal = selected.reduce((sum, item) => sum + (item.amount || 0), 0);
    this.fillChequePayment["amount"] = this.avisTotal
  };

  async onlineInit() {
   
    if (this.comp?.type?.id) {
      let res = await this.categoryService.getCategory("category", this.comp.type.id).toPromise();
      if (res.avis) {
        await this.avisPaymentsSetup();
      } else {
        this.revenueCodeBasedPaymentsSetup(false);
      }
    }
  }

  async offlineInit() {
    if (this.comp?.type) {
      let res = await this.companyDexieService.getCategoryById(this.comp.type)
      if (res.avis) {
        await this.avisPaymentsSetup();
      } else {
        this.revenueCodeBasedPaymentsSetup();
      }
    }
  }

  transformTaxname = (elem) =>
    ({
      amount: elem.amount,
      name: elem.name,
      id: elem.id,
      revenueCode: elem.revenueCode.length > 0 ? elem.revenueCode[0] : null
    })

  async revenueCodeBasedPaymentsSetup(offline = true) {
    if (offline) {
      let comp = await this.companyDexieService.getCompanyByTin(this.data['tin'])
      this.taxNames = await this.companyDexieService.getTaxNamesByMunicipalityAndType(comp.municipality, comp.type)
    }
    else {
      this.taxNames = await this.taxNameService.getTaxNamesForTaxpayer("tax-name", this.data).toPromise()
    }
    this.taxNames = this.taxNames.map(this.transformTaxname)
  }

  private async avisPaymentsSetup() {
    let avises = this.isOnline ? await this.avisService.getUnpaidAvises(this.data["tin"]).toPromise() : this.comp.avises
    if (avises.length === 0) this.taxNames = [];
    let txNames = [];
    let index = 0;
    for (let elem of avises) {
      let proc;
      if (this.isOnline) {
        try {
          proc = await this.processService.getProcess(elem.processId).toPromise();
        } catch (error) {
          continue;
        }
      }
      else {
        proc = { name: elem.name, month: elem.month, year: elem.year }
      }
      txNames.push({
        amount: elem.total, name: this.convertDate(elem.submission_date) + " " + elem.total.toLocaleString() + environment.currency.currencyName + " " +
          (elem.processName || "") +
          (elem.rec_num ? " - " + elem.rec_num : ""),
        id: elem.id,
        avis: true,
        month: (proc && proc["month"]) || null,
        origName: (proc && proc.name) || null,
        year: (proc && proc.year) || null,
        revenueCode: {
          code: elem.revenueCode || "",
          id: elem.revenueCodeId || "",
        },
        reference_number: elem.reference_number,
      });
      if (index === avises.length - 1) {
        this.taxNames = txNames.map(txName => {
          if (txName.avis && txName.month) {
            return {
              ...txName,
              name: `${this.translate.instant("MONTHS_FR." + (txName.month < 10 ? '0' + txName.month : txName.month))}-${txName.year} ${txName.amount.toLocaleString('en-GB') + environment.currency.currencyName} ${txName.origName}`
            };
          } return txName;
        });
        this.sortedDataByYearsAndMonths(this.taxNames);
      }
      index++;
    }
    txNames.length === 0 && (this.taxNames = []);
  }

  convertDate = (dateStr) => {
    if (isNaN(Date.parse(dateStr))) {
      return "";
    }
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  sortedDataByYearsAndMonths(data) {
    data.sort((a, b) => {
      if (a.year < b.year) return -1;
      if (a.year > b.year) return 1;
      if (a.month === null && b.month !== null) return -1;
      if (a.month !== null && b.month === null) return 1;
      if (a.month < b.month) return -1;
      if (a.month > b.month) return 1;
      return 0;
    })
  }
}
